interface SummaryCardProps {
  label: string;
  value: number | string;
  icon: string;
  colorClass: string;
  suffix?: string;
}

export default function SummaryCard({ label, value, icon, colorClass, suffix }: SummaryCardProps) {
  return (
    <div className="bg-white rounded-xl p-4 md:p-5 border border-stone-200/80 hover:border-stone-300 transition-all duration-200 cursor-pointer group">
      <div className="flex items-start justify-between mb-3">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${colorClass}`}>
          <i className={`${icon} text-lg`} />
        </div>
      </div>
      <div>
        <p className="text-2xl md:text-3xl font-bold text-stone-900 tracking-tight">
          {value}
          {suffix && <span className="text-base font-medium text-stone-400 ml-0.5">{suffix}</span>}
        </p>
        <p className="text-xs md:text-sm text-stone-500 mt-1 leading-tight">{label}</p>
      </div>
    </div>
  );
}